/**
 * Ways sends times as unix SECONDS (floats: runner createdAt, presence at); PMO sends ISO strings.
 * `new Date(seconds)` reads them as milliseconds and lands in January 1970, which is what the
 * Runners view showed (hs-pmo/ep19#43). Anything below 1e12 is taken as seconds.
 */
export function toDate(v: number | string | null | undefined): Date | null {
  if (v == null || v === '') return null;
  const d = typeof v === 'number' ? new Date(v < 1e12 ? v * 1000 : v) : new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** "just now", "4m ago", "2h ago", "3d ago"; "in 5h" for a time ahead (a lease). */
export function relTime(v: number | string | null | undefined, now = Date.now()): string {
  const d = toDate(v);
  if (!d) return '—';
  const s = Math.round((d.getTime() - now) / 1000);
  const a = Math.abs(s);
  const n = a < 60 ? null : a < 3600 ? `${Math.round(a / 60)}m` : a < 86400 ? `${Math.round(a / 3600)}h` : `${Math.round(a / 86400)}d`;
  if (!n) return s > 0 ? 'in under a minute' : 'just now';
  return s > 0 ? `in ${n}` : `${n} ago`;
}
